import { axiosPost } from "./ajaxServices";
import {
  urlCreateShopProduct,
  urlUpdateShopProduct,
  urlGetShopProductList,
  urlDeleteShopProduct,
  urlUpdateShopProductPosition,
} from "./CONSTANTS";

// Keep only the fields the backend understands for each variant.
function normalizeVariants(variants) {
  if (!Array.isArray(variants)) return [];
  return variants.map((v) => {
    const out = {
      name: v.name !== undefined ? v.name : "",
      weight: v.weight !== undefined ? v.weight : "",
      sku: v.sku !== undefined ? v.sku : "",
      price: v.price !== undefined && v.price !== null ? v.price : 0,
      stock_qty: v.stock_qty !== undefined && v.stock_qty !== null ? v.stock_qty : 0,
      status: v.status !== undefined ? v.status : "1",
    };
    // Preserve id for existing variants so the backend updates instead of inserting
    if (v.id !== undefined && v.id !== null && v.id !== "") {
      out.id = v.id;
    }
    return out;
  });
}

function appendImages(formData, data) {
  if (data.image_name) {
    if (Array.isArray(data.image_name)) {
      data.image_name.forEach((file) => {
        if (file instanceof File) {
          formData.append("image_name[]", file);
        }
      });
    } else if (data.image_name instanceof File) {
      formData.append("image_name", data.image_name);
    }
  }
}

export function apiCreateShopProduct(data) {
  const url = urlCreateShopProduct;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("name", data.name);
  formData.append("description", data.description || "");
  formData.append("category_id", data.category_id || "");
  formData.append("status", data.status);
  formData.append("variants", JSON.stringify(normalizeVariants(data.variants)));
  appendImages(formData, data);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiUpdateShopProduct(data) {
  const url = urlUpdateShopProduct;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", data.id);
  formData.append("name", data.name);
  formData.append("description", data.description || "");
  formData.append("category_id", data.category_id || "");
  formData.append("status", data.status);
  formData.append("variants", JSON.stringify(normalizeVariants(data.variants)));

  // Send remaining existing images (after removals) so the backend keeps them.
  if (data.thumbnail_image !== undefined) {
    if (Array.isArray(data.thumbnail_image)) {
      formData.append("thumbnail_image", JSON.stringify(data.thumbnail_image));
    } else if (data.thumbnail_image && data.thumbnail_image !== "") {
      formData.append("thumbnail_image", data.thumbnail_image);
    } else {
      formData.append("thumbnail_image", "[]");
    }
  }

  appendImages(formData, data);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const apiGetShopProductList = (currentPage, pageSize, startDate, endDate) => {
  const url = urlGetShopProductList;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export function apiUpdateShopProductPosition(dataList) {
  const url = urlUpdateShopProductPosition;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var idList = [];
  for (let i = 0; i < dataList.length; i++) {
    idList.push({ id: dataList[i]["id"] });
  }
  var formData = new FormData();
  formData.append("dataList", JSON.stringify(idList));
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiDeleteShopProduct(id) {
  const url = urlDeleteShopProduct;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
